import React from 'react'
import {
  InstructionsContainer,
  InstructionsDescription,
  InstructionsImages,
} from './Instructions.styled'
import { OutsideLink, StyledText } from '@clickcease/cc-client-components-lib'
import { Trans, useTranslation } from 'react-i18next'

export const Instructions = () => {
  const { t } = useTranslation('googleAnalytics')

  return (
    <InstructionsContainer>
      <InstructionsDescription>
        <StyledText variant={'baseLight'}>{t('instructions.step1')}</StyledText>
        <StyledText variant={'baseLight'}>{t('instructions.step2')}</StyledText>
        <StyledText variant={'baseLight'}>
          <Trans ns="googleAnalytics" i18nKey="instructions.step3">
            Next, create a Custom Dimension called cq_category.
            <OutsideLink href="https://cheqessentials.zendesk.com/hc/en-us/articles/13194759454225">
              Learn more
            </OutsideLink>
          </Trans>
        </StyledText>
        <StyledText variant={'baseLight'}>
          <Trans ns="googleAnalytics" i18nKey="instructions.step4">
            Analyze your detection data.
            <OutsideLink href="https://cheqessentials.zendesk.com/hc/en-us/articles/13194792471057">
              Learn more
            </OutsideLink>
          </Trans>
        </StyledText>
      </InstructionsDescription>
      <InstructionsImages></InstructionsImages>
    </InstructionsContainer>
  )
}
